var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadCrmStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.97241 15.3086V46.2714C1.97241 47.5189 2.98377 48.5301 4.23115 48.5301H46.7707C48.018 48.5301 49.0294 47.5189 49.0294 46.2714V15.3086H1.97241Z",
    fill: "#D9DCEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0439 48.5251H4.22932C2.98709 48.5251 1.97058 47.5162 1.97058 46.2664V15.3066H14.7852V46.2664C14.7852 47.5162 15.7941 48.5251 17.0439 48.5251Z",
    fill: "#C4CAE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0276 15.3069V7.71577C49.0276 6.4683 48.0164 5.45703 46.7688 5.45703H4.22932C2.98194 5.45703 1.97058 6.4683 1.97058 7.71577V15.3069H49.0276Z",
    fill: "#F79839"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0439 5.45898C15.7941 5.45898 14.7852 6.46786 14.7852 7.71772V15.3071H1.97058V7.71772C1.97058 6.46786 2.98709 5.45898 4.22932 5.45898H17.0439Z",
    fill: "#EE8524"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9612 3.18326V10.3814H18.54V3.18326C18.54 2.23852 19.3059 1.47266 20.2506 1.47266C21.1954 1.47266 21.9612 2.23852 21.9612 3.18326Z",
    fill: "#FADB43"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1097 1.70313C20.5978 1.99673 20.2515 2.55392 20.2515 3.18634V10.3842H18.5424V3.18634C18.5424 2.23767 19.3026 1.46973 20.2515 1.46973C20.5677 1.46973 20.8612 1.55254 21.1097 1.70313Z",
    fill: "#E8C635"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1903 10.933H17.3109C17.0064 10.933 16.7594 10.686 16.7594 10.3815C16.7594 10.0771 17.0064 9.83008 17.3109 9.83008H23.1903C23.4948 9.83008 23.7418 10.0771 23.7418 10.3815C23.7418 10.686 23.4948 10.933 23.1903 10.933Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4617 3.18326V10.3814H29.0405V3.18326C29.0405 2.23852 29.8064 1.47266 30.7511 1.47266C31.6959 1.47266 32.4617 2.23852 32.4617 3.18326Z",
    fill: "#FADB43"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6052 1.69559C31.0933 1.99673 30.7545 2.55392 30.7545 3.18634V10.3842H29.0378V3.18634C29.0378 2.23767 29.8058 1.46973 30.7545 1.46973C31.0631 1.46973 31.3569 1.55254 31.6052 1.69559Z",
    fill: "#E8C635"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6908 10.933H27.8117C27.5073 10.933 27.2603 10.686 27.2603 10.3815C27.2603 10.0771 27.5073 9.83008 27.8117 9.83008H33.6908C33.9953 9.83008 34.2423 10.0771 34.2423 10.3815C34.2423 10.686 33.9953 10.933 33.6908 10.933Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9625 3.18326V10.3814H39.5413V3.18326C39.5413 2.23852 40.3071 1.47266 41.2519 1.47266C42.1966 1.47266 42.9625 2.23852 42.9625 3.18326Z",
    fill: "#FADB43"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1083 1.69559C41.5963 1.99673 41.25 2.54639 41.25 3.18634V10.3842H39.5409V3.18634C39.5409 2.23767 40.3089 1.46973 41.25 1.46973C41.5662 1.46973 41.8599 1.55254 42.1083 1.69559Z",
    fill: "#E8C635"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1918 10.933H38.3123C38.0079 10.933 37.7609 10.686 37.7609 10.3815C37.7609 10.0771 38.0079 9.83008 38.3123 9.83008H44.1918C44.4963 9.83008 44.7433 10.0771 44.7433 10.3815C44.7433 10.686 44.4963 10.933 44.1918 10.933Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4605 3.18326V10.3814H8.03931V3.18326C8.03931 2.23852 8.80517 1.47266 9.74991 1.47266C10.6947 1.47266 11.4605 2.23852 11.4605 3.18326Z",
    fill: "#FADB43"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6066 1.69559C10.0945 1.99673 9.74819 2.54639 9.74819 3.18634V10.3842H8.03906V3.18634C8.03906 2.23767 8.80705 1.46973 9.74819 1.46973C10.0643 1.46973 10.3581 1.55254 10.6066 1.69559Z",
    fill: "#E8C635"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6897 10.933H6.81026C6.5058 10.933 6.25879 10.686 6.25879 10.3815C6.25879 10.0771 6.5058 9.83008 6.81026 9.83008H12.6897C12.9942 9.83008 13.2412 10.0771 13.2412 10.3815C13.2412 10.686 12.9942 10.933 12.6897 10.933Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1994 41.5102C38.1994 42.285 37.5713 42.9131 36.7965 42.9131H14.2053C13.4306 42.9131 12.8025 42.285 12.8025 41.5102C12.8025 40.7355 13.4306 40.1074 14.2053 40.1074H36.7965C37.5713 40.1074 38.1994 40.7355 38.1994 41.5102Z",
    fill: "#70BF67"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9613 28.0918V36.1121C28.9613 36.528 28.6242 36.8651 28.2084 36.8651H22.7943C22.3785 36.8651 22.0414 36.528 22.0414 36.1121V28.0918H28.9613Z",
    fill: "#70BF67"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2915 28.0955H20.7103C20.2279 28.0955 19.9591 27.5382 20.2594 27.1607L25.046 21.1423C25.2765 20.8524 25.7168 20.8523 25.9476 21.142L30.7421 27.1603C31.0428 27.5378 30.7741 28.0955 30.2915 28.0955Z",
    fill: "#70BF67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadCrmStep1);
export default __webpack_public_path__ + "static/media/lead_crm_step1.c594fa80f41f0880f507c2d71bf67561.svg";
export { ForwardRef as ReactComponent };